import type { Auth } from '../types';
import { AuthApi } from '../api';

export async function isAuth(role: Auth['role']) {
  try {
    const auth = await AuthApi.isAuth({ version: 2 });
    return auth.isAuth && auth.role === role;
  } catch (err) {
    console.error(err);
    return false;
  }
}
